import React from "react";

export type AppContextType = {
  username: string;
  email: string;
  isSuperuser: boolean;
};

export const AppContext = React.createContext<AppContextType>({
  username: "pre-login",
  email: "pre-login@example.com",
  isSuperuser: false,
});
